// extracted by mini-css-extract-plugin
export default {"form":"item_form__rIp+G","titles":"item_titles__G0YnW","form_body_top":"item_form_body_top__MqVlc"};